import { render } from "./Card.vue?vue&type=template&id=13bfcf96&scoped=true"
import script from "./Card.vue?vue&type=script&lang=js"
export * from "./Card.vue?vue&type=script&lang=js"

import "./Card.vue?vue&type=style&index=0&id=13bfcf96&scoped=true&lang=css"

import exportComponent from "/home/josearpaia/Documentos/etyalab/cositas-en-vue/api-banderas-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13bfcf96"]])

export default __exports__